import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Address } from '@spartacus/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { BehaviorSubject, Observable, Subscription } from 'rxjs'
import { take } from 'rxjs/operators'
import { EbCheckoutDeliveryService } from '../../services/facades/eb-checkout-delivery.service'

@Component({
    selector: 'eb-shipping-address-dialog',
    templateUrl: './eb-shipping-address-dialog.component.html',
    styleUrls: ['./eb-shipping-address-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EbShippingAddressDialogComponent implements OnInit, OnDestroy {
  shippingAddressForm: UntypedFormGroup
  selectedAddress$: Observable<Address | undefined>
  submitting$: BehaviorSubject<false>
  currentShippingAddressId: string
  selectedAddressSubscription: Subscription
  constructor(
    protected modalService: LaunchDialogService,
    protected ebCheckoutDeliveryService: EbCheckoutDeliveryService
  ) {}

  ngOnInit(): void {
    this.modalService.data$.subscribe(dialogData => {
      this.shippingAddressForm = dialogData.shippingAddressForm
      this.selectedAddress$ = dialogData.selectedAddress$
      this.submitting$ = dialogData.submitting$
      this.currentShippingAddressId = dialogData.currentShippingAddressId
    })
  }

  chooseSubmit() {
    if (this.shippingAddressForm.get('ebCommerceAddress').value === true) {
      if (this.shippingAddressForm.get('id').value !== null) {
        this.onSubmitEditCommerceAddress()
      } else {
        this.onSubmitNewCommerceAddress()
      }
    } else this.onSubmit()
  }

  onSubmitNewCommerceAddress() {
    this.selectedAddressSubscription = this.selectedAddress$.subscribe(address => {
      this.ebCheckoutDeliveryService
        .submitNewAddressForm({
          companyName: this.shippingAddressForm.value?.companyName,
          line1: this.shippingAddressForm.value?.street,
          line2: this.shippingAddressForm.value?.houseNumber,
          town: this.shippingAddressForm.value?.city,
          postalCode: this.shippingAddressForm.value?.zip,
          country: address.country,
          ebCommerceAddress: true,
          name3: this.shippingAddressForm.value?.additionalInformation
        })
        .pipe(take(1))
        .subscribe(() => {
          this.submitting$.next(false)
          this.dismissModal('New shipping address created')
        })
    })
  }
  onSubmitEditCommerceAddress() {
    this.selectedAddress$.subscribe(address => {
      this.ebCheckoutDeliveryService
        .submitEditCommerceAddressForm(this.shippingAddressForm.get('id').value, {
          companyName: this.shippingAddressForm.value?.companyName,
          line1: this.shippingAddressForm.value?.street,
          line2: this.shippingAddressForm.value?.houseNumber,
          town: this.shippingAddressForm.value?.city,
          postalCode: this.shippingAddressForm.value?.zip,
          country: address.country,
          ebCommerceAddress: true,
          id: this.shippingAddressForm.get('id').value,
          name3: this.shippingAddressForm.value?.additionalInformation
        })
        .pipe(take(1))
        .subscribe(() => {
          this.submitting$.next(false)
          this.dismissModal('New shipping address Edited')
        })
    })
  }

  onSubmit() {
    this.ebCheckoutDeliveryService
      .submitEditAddressForm(
        this.currentShippingAddressId,
        this.shippingAddressForm.value?.additionalInformation
      )
      .pipe(take(1))
      .subscribe(() => {
        this.submitting$.next(false)
        this.dismissModal('new attention of shipping address created')
      })
  }

  dismissModal(reason?: any): void {
    this.modalService.closeDialog(reason)
  }

  ngOnDestroy(): void {
    this.selectedAddressSubscription?.unsubscribe()
  }
}
